import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getUser } from '~/store/reducers/users'

import { usePaymentDialog } from '../context/PaymentDialogProvider'

import styles from './ClientNotes.module.scss'

export const ClientNotes = () => {
  const { invoice } = usePaymentDialog()
  const client = useSelector(getUser(invoice?.clientId))
  const { t } = useTranslation('Common')
  return (
    <div className={styles.clientNotesContainer}>
      <h4 className={styles.sectionTitle}>{t('Common:CLIENT_NOTES')}</h4>
      <div className={styles.notes}>{client?.notes}</div>
    </div>
  )
}
